import { render, staticRenderFns } from "./awemeAction.vue?vue&type=template&id=4f5f56ad&scoped=true"
import script from "./awemeAction.vue?vue&type=script&lang=js"
export * from "./awemeAction.vue?vue&type=script&lang=js"
import style0 from "./awemeAction.vue?vue&type=style&index=0&id=4f5f56ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5f56ad",
  null
  
)

export default component.exports